import {put, select, takeEvery} from 'redux-saga/effects'

import {closeDashboard} from '../actions/dashboard'
import {OPEN_MOBILE_MENU} from '../actions/mobileMenu'
import * as dashboard from '../store/dashboard'

export function* mobileMenuOpenWorker() {
  if (yield select(dashboard.isOpen)) {
    yield put(closeDashboard())
  }
}

export function* mobileMenuOpenSaga() {
  yield takeEvery(OPEN_MOBILE_MENU, mobileMenuOpenWorker)
}
